import React from 'react';
import cn from 'classnames/bind';

import SearchTable from '../../components/SearchTable/SearchTable';
import SearchTableHead from '../../components/SearchTableHead/SearchTableHead';
import SearchTableHeadCell from '../../components/SearchTableHeadCell/SearchTableHeadCell';
import DatepickerTableHeadCell from '../../components/DatepickerTableHeadCell/DatepickerTableHeadCell';
import SearchTableBody from '../../components/SearchTableBody/SearchTableBody';
import SearchTableBodyCell from '../../components/SearchTableBodyCell/SearchTableBodyCell';
import Sprite from '../../../../components/Sprite';

import styles from './GoatsSearchTable.module.css';
import { convertDate } from '../../../../utils/helpers';

const cx = cn.bind(styles);

function GoatsSearchTable(props) {
  function handleRowClick(id) {
    props.history.push(`/goat/${id}/`);
  }

  function handleOrderClick(name, values, actions) {
    if (values.orderBy === name) {
      actions.setFieldValue('orderBy', `-${name}`);
      props.onFilter({ ...values, orderBy: `-${name}` }, actions);
    } else {
      actions.setFieldValue('orderBy', name);
      props.onFilter({ ...values, orderBy: name }, actions);
    }
  }

  return (
    <section className={styles.wrapper}>
      <SearchTable>
        <SearchTableHead rowClassName={cx({ 'table-row': true })}>
          <SearchTableHeadCell
            className={cx({ 'table-cell': true })}
            name="tag"
            icon="magnifier"
            actions={props.actions}
          >
            <button
              type="button"
              icon="magnifier"
              onClick={() => handleOrderClick('tag', props.values, props.actions)}
            >
              Номер бирки
              <Sprite
                name="sort-arrow"
                role="img"
                className={cx({ arrow: true, 'arrow-ordered': props.values.orderBy === '-tag' })}
              />
            </button>
          </SearchTableHeadCell>

          <SearchTableHeadCell
            className={cx({ 'table-cell': true })}
            name="chip"
            icon="magnifier"
            actions={props.actions}
          >
            Номер чипа
          </SearchTableHeadCell>

          <SearchTableHeadCell
            className={cx({ 'table-cell': true })}
            name="name"
            icon="magnifier"
            actions={props.actions}
          >
            Кличка
          </SearchTableHeadCell>

          <DatepickerTableHeadCell
            className={cx({ 'table-cell': true })}
            name="birthDate"
            icon="calendar"
            actions={props.actions}
            value={props.values.birthDate}
          >
            Дата рождения
          </DatepickerTableHeadCell>

          <SearchTableHeadCell
            className={cx({ 'table-cell': true })}
            name="emrId"
            icon="magnifier"
            actions={props.actions}
          >
            Номер ЭМК
          </SearchTableHeadCell>

          <DatepickerTableHeadCell
            className={cx({ 'table-cell': true })}
            name="modified"
            icon="calendar"
            actions={props.actions}
            popperPlacement="bottom-end"
            value={props.values.modified}
          >
            Обновлено
          </DatepickerTableHeadCell>

          <SearchTableHeadCell
            className={cx({ 'table-cell': true })}
            name="group"
            icon="magnifier"
            actions={props.actions}
          >
            Группа
          </SearchTableHeadCell>
        </SearchTableHead>

        <SearchTableBody results={props.goats.results.length}>
          {props.goats.results.map(({ id, tag, chip, name, birthDate, emr, modified, group }) => {
            modified = convertDate(modified, 'd.LL.yyyy HH:mm');
            birthDate = birthDate && convertDate(birthDate, 'd.LL.yyyy');

            return (
              <tr
                key={id}
                onClick={() => handleRowClick(id)}
                className={cx({ 'table-row': true, 'table-body-row': true })}
              >
                <SearchTableBodyCell className={cx({ 'table-cell': true })}>
                  {tag}
                </SearchTableBodyCell>

                <SearchTableBodyCell className={cx({ 'table-cell': true })}>
                  {chip}
                </SearchTableBodyCell>

                <SearchTableBodyCell className={cx({ 'table-cell': true })}>
                  {name}
                </SearchTableBodyCell>

                <SearchTableBodyCell className={cx({ 'table-cell': true })}>
                  {birthDate}
                </SearchTableBodyCell>

                <SearchTableBodyCell className={cx({ 'table-cell': true })}>
                  {emr}
                </SearchTableBodyCell>

                <SearchTableBodyCell className={cx({ 'table-cell': true })}>
                  {modified}
                </SearchTableBodyCell>

                <SearchTableBodyCell className={cx({ 'table-cell': true })}>
                  {group?.name || ''}
                </SearchTableBodyCell>
              </tr>
            );
          })}
        </SearchTableBody>
      </SearchTable>

      <div className={styles.footer}>{props.children}</div>
    </section>
  );
}

export default GoatsSearchTable;
